// extracted by mini-css-extract-plugin
module.exports = {"flashMsg":"styles_flashMsg__wqkVL","flashMsg__mobile":"styles_flashMsg__mobile__XqxoR","flashMsg__desktop":"styles_flashMsg__desktop__eUrey"};